import { Collapse, Row } from 'antd'
import styled from 'styled-components'

import { Card as CardComp } from 'src/components/Ant'

const WrapCard = styled(CardComp)`
  margin-bottom: 16px;
`

const WrapCollapsePanel = styled(Collapse.Panel)<{ highlight?: boolean }>`
  ${({ highlight }) => {
    if (highlight) {
      return { backgroundColor: '#b7eb8f' }
    }
  }}
  border: '1px dashed #e8e8e8';
  border-radius: 4;
  margin-bottom: 24;
  overflow: 'hidden';
`

const WrapRow = styled(Row)`
  background: #fbfbfb;
  border: '1px dashed #e8e8e8';
  border-radius: 4;
  overflow: 'hidden';
  padding: 16;
`

export { WrapCard, WrapCollapsePanel, WrapRow }
